<script>
export default {
  name: "lookup-widget",
  data() {
    return {
      lookup: null,
      working: false
    }
  },
  methods: {
    do_lookup() {
      this.working = true
      this.global_lookup(this.lookup).finally(() => this.working = false)
    },
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<template>
  <b-input-group size="sm" style="max-width: 150px">
    <b-input :disabled="working" size="sm" @keydown.enter.prevent="do_lookup()" placeholder="Lookup" ref="input" v-model="lookup"/>
    <b-input-group-append>
      <b-button size="sm" variant="outline-success" class="px-2" @click.prevent="do_lookup()">
        <b-spinner small v-if="working" />
        <font-awesome-icon :icon="['fas', 'magnifying-glass']" v-else/>
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<style scoped>

</style>